import React, {useContext, useEffect, useState} from "react";
import { Alert, Button, FormControl, InputGroup, Table, Form } from "react-bootstrap";
import { Context } from "../../index";
import { toast } from "react-toastify";
import {getAffiliateAliasByUserIdApi, setAffiliateAliasApi, setAffiliateNameApi} from "../../http/affiliateAPI";
import {fetchReferredUsers} from "../../http/userAPI";

const ReferralPanel = ({ referralLink }) => {
    const { user } = useContext(Context);
    const [alias, setAlias] = useState("");
    const [loading, setLoading] = useState(false);
    const [referrals, setReferrals] = useState([]);
    const [savedAlias, setSavedAlias] = useState("");
    const [ref_name, setRefName] = useState("");
    const [ref_message, setRefMessage] = useState("");

    useEffect(() => {
        if (user?.user?.id) {
            fetchReferredUsers(user.user.id).then(setReferrals);
            getAffiliateAliasByUserIdApi(user.user.id)
                .then((data) => {
                    if (data?.alias) {
                        setAlias(data.alias.trim());
                        setSavedAlias(data.alias.trim()); // если хочешь сразу отобразить alias-ссылку
                        setRefName(data.ref_name);
                        setRefMessage(data.ref_message);
                    }
                })
                .catch((e) => {
                    console.warn("Failed to fetch alias:", e);
                });

        }
    }, [user?.user?.id]);

    const handleCopy = () => {
        navigator.clipboard.writeText(referralLink).then(() => {
            toast.info("Your Referral link copied!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        });

    };


    const formatDate = (minutes) => {
        const ms = minutes * 60 * 1000;
        const date = new Date(ms);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' }); // Apr
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const mins = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${mins}`;
    };

    const fullAliasLink = savedAlias ? `${window.location.origin}/${savedAlias}` : "";

    const handleSetAlias = async () => {
        if (!alias.trim()) return;
        setLoading(true);
        try {
            const response = await setAffiliateAliasApi({
                userId: user.user.id,
                slug: alias.trim().toLowerCase(),
             });
            setSavedAlias(alias.trim().toLowerCase());
         toast.info(response.message || "Alias updated successfully", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (e) {
            toast.error(e.response?.data?.message || "Failed to set alias", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const handleSetName = async () => {
        if (!alias.trim()) return;
        setLoading(true);
        try {
            const response = await setAffiliateNameApi({
                userId: user.user.id,
                ref_name,
                ref_message,
            });
             toast.info(response.message || "Data Updated Successfully", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (e) {
            toast.error(e.response?.data?.message || "Failed to set", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const handleCopyAlias = () => {
        if (!fullAliasLink) return;
        navigator.clipboard.writeText(fullAliasLink);
        toast.info("Your Own Alias link copied!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
    };

    return (
        <>
            <Alert variant="success bg-light" className="w-100 mt-3">
                <h6 className="text-muted">Your Simple Referral Link:</h6>
                <InputGroup className="mt-2 mb-3 input-group-sm flex-wrap">
                    <FormControl className="text-muted" value={referralLink} readOnly />
                    <Button onClick={handleCopy} variant="outline-success">Copy Referral Link</Button>
                </InputGroup>

                <p className="small text-muted fst-italic">
                    * Sometimes the parameters of plain links can be lost by social media. Create a personalized alias link to avoid issues.
                </p>

                <h6 className="text-muted mt-3 fw-semibold">
                    Set Your Own Alias:
                </h6>

                <div className="w-100 mb-3 mt-2" style={{ maxWidth: "500px" }}>
                    <Form.Label className="small text-muted mb-1">
                        Alias (lowercase letters, numbers, hyphens, underscores) ({alias.length}/100)
                    </Form.Label>

                    <InputGroup size="sm">
                        <FormControl
                            placeholder="Set your alias (e.g. anna)"
                            className="text-muted"
                            value={alias}
                            maxLength={100}
                            onChange={(e) => {
                                const raw = e.target.value;

                                const cleaned = raw
                                    .toLowerCase()
                                    .replace(/[^a-z0-9_-]/g, "");

                                setAlias(cleaned);
                            }}
                        />

                        <Button
                            variant="success"
                            onClick={handleSetAlias}
                            disabled={loading || !alias || alias === savedAlias}
                        >
                            Save Alias
                        </Button>
                    </InputGroup>
                </div>




                <InputGroup className="mb-3 input-group-sm flex-wrap">
                    <FormControl className="text-muted small" value={fullAliasLink} placeholder="Save an alias to generate your personal link" readOnly />
                    <Button onClick={handleCopyAlias} variant="outline-success btn-sm" disabled={!savedAlias}>Copy Alias Link</Button>
                </InputGroup>

                {savedAlias && (
                    <>
                        <p className="small text-muted fst-italic">
                            * Great! Your personal link is ready: <span className="text-success">{fullAliasLink}</span>.
                            Now you can set two optional parameters: <br />
                            1) A name shown during registration (“You were invited by Name”).<br />
                            2) A custom message shown in referred users' dashboards (“Message from Affiliate”).<br />
                            You may also include helpful details here — for example, your personal promo code, if you have one.<br />
                            You can update or delete these fields anytime by saving new values or clearing them.
                        </p>


                        <h6 className="text-muted mt-3">Set Your Own Name and Message:</h6>
                        <div className="d-flex flex-column flex-md-row gap-2 mt-2">
                            <div className="flex-fill">
                                <Form.Label className="small text-muted mb-1">Name for Homepage: ({ref_name.length}/50)</Form.Label>
                                <FormControl
                                    size="sm"
                                    placeholder="Set your Name"
                                    className="text-muted"
                                    value={ref_name}
                                    maxLength={50}
                                    onChange={(e) => setRefName(e.target.value)}
                                />
                            </div>

                            <div className="flex-fill">
                                <Form.Label className="small text-muted mb-1">Message for Partners: ({ref_message.length}/250)</Form.Label>
                                <FormControl
                                    size="sm"
                                    placeholder="Set your Message"
                                    className="text-muted"
                                    value={ref_message}
                                    maxLength={250}                                  // ← жёсткое ограничение ввода
                                    onChange={(e) => setRefMessage(e.target.value)}
                                />
                            </div>


                            <div className="d-flex flex-column justify-content-end">
                                <Form.Label className="invisible mb-1">Save</Form.Label>
                                <Button
                                    size="sm"
                                    variant="success"
                                    style={{ maxWidth: "190px" }}
                                    onClick={handleSetName}
                                    disabled={loading || !savedAlias}
                                >
                                    Save Name & Message
                                </Button>
                            </div>
                        </div>
                    </>
                )}
            </Alert>

         {referrals.length > 0 ? (
                <>
                    <h6 className="mt-3 text-muted">All Your Referred Users:</h6>
                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                        <Table striped bordered hover size="sm" className="w-100 small text-muted fst-italic mb-0" style={{  lineHeight: '14px' }}>
                            <thead className="small text-muted">
                            <tr>
                                <th className="text-muted text-nowrap">ID</th>
                                <th className="text-muted text-nowrap">Username</th>
                                <th className="text-muted text-nowrap">Registration</th>
                                <th className="text-muted text-nowrap">Was Referred by Model</th>
                                <th className="text-muted text-nowrap">Current Plan</th>
                                <th className="text-muted text-nowrap">Your Bonus</th>
                            </tr>
                            </thead>
                            <tbody>
                            {referrals.map((ref) => (
                                <tr key={ref.id} className="small">
                                    <td className="text-muted text-nowrap">{ref.id}</td>
                                    <td className="text-muted text-nowrap">{ref.username}</td>
                                    <td className="text-muted text-nowrap">{formatDate(ref.registration_date)}</td>
                                    <td className="text-muted text-nowrap">{ref.ref_affiliate_model_level1 || "VIRT"}</td>
                                    <td className="text-muted text-nowrap">{ref.tariff_plan}</td>
                                    <td className="text-muted text-nowrap">{ref.what_bonus_get_referrer || "-"}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </div>
                </>

            ) : (
                <p className="text-muted">You haven't referred anyone yet.</p>
            )}

        </>
    );
};

export default ReferralPanel;
